import { TransactionState } from '@app/store/domain';

export type Member = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  image: {
    url: string | null;
  };
  isUpdating?: boolean;
};

export type PageInfo = {
  hasNextPage: boolean;
  endCursor: string | null;
};

export type TabState = {
  members: Member[];
  pageInfo: PageInfo;
  searchQuery: string;
  sortKey: string;
  reverse: boolean;
  error: {
    message: string;
  };
} & TransactionState;

const defaultTabState: TabState = {
  status: 'idle',
  members: [],
  pageInfo: {
    hasNextPage: false,
    endCursor: null,
  },
  searchQuery: '',
  sortKey: 'FIRST_NAME',
  reverse: false,
  error: {
    message: '',
  },
};

export type ActiveTab = 'with-access' | 'without-access';

export type State = {
  eventId: string;
  activeTab: ActiveTab;
  withAccess: TabState;
  withoutAccess: TabState;
  isBulkActionPending: boolean;
};

export const defaultState: State = {
  eventId: '',
  activeTab: 'with-access',
  withAccess: defaultTabState,
  withoutAccess: defaultTabState,
  isBulkActionPending: false,
};
